module.exports = __webpack_public_path__ + "img/meal.9f4db81f.svg";